import { useState } from 'react';

// Export useAuth from AuthContext
export { useAuth } from '../contexts/AuthContext';

// Export useClients hook from dedicated file
export { useClients } from './useClients';

// Modal hook
export const useModal = <T = any>() => {
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState<T | null>(null);

  const openModal = (content?: T) => {
    setData(content || null);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setData(null);
  };

  return { 
    isOpen, 
    data, 
    modalContent: data, // Keep backward compatibility
    openModal, 
    closeModal 
  };
};


// Filters hook
export const useFilters = <T>(
  items: T[],
  filterFn: (item: T, filters: any) => boolean,
  initialFilters: any = {}
) => {
  const [filters, setFilters] = useState(initialFilters);

  const updateFilter = (key: string, value: any) => {
    setFilters((prev: any) => ({ ...prev, [key]: value }));
  };

  const resetFilters = () => {
    setFilters(initialFilters);
  };

  const filteredItems = items.filter(item => filterFn(item, filters));

  return {
    filters,
    filteredItems,
    updateFilter,
    resetFilters,
    setFilters
  };
};